import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * Location Schema
 * Represents a physical location/venue for games.
 * Supports hierarchical venues via parentLocation:
 * - parentLocation: null = top-level venue (e.g., "North High School")
 * - parentLocation: <venueId> = sub-venue (e.g., "Court 1")
 */
export const LocationSchema = z.object({
  _id: objectId,
  name: z.string().default(''),
  parentLocation: objectId,
  address1: z.string().optional(),
  address2: z.string().optional(),
  city: z.string().optional(),
  zipCode: z.string().optional(),
  state: z.string().optional(),
  organization: objectId,
  ...timestampFields,
});

export type Location = z.infer<typeof LocationSchema>;

export const locationMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'Name', editable: true },
  parentLocation: { ref: 'Location', label: 'Parent Venue' },
  address1: { label: 'Address Line 1', editable: true },
  address2: { label: 'Address Line 2', editable: true },
  city: { label: 'City', editable: true },
  zipCode: { label: 'Zip Code', editable: true },
  state: { label: 'State', editable: true },
  organization: { ref: 'Organization', label: 'Organization' },
  created: { hidden: true },
  updated: { hidden: true },
};
